<template>
    <v-dialog persistent max-width="500" :value="true">
      <v-card>
        <v-card-title>Update comments</v-card-title>
        <v-divider/>
        <v-card-text class="pb-0 pt-2 px-0">
          <v-form>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field label="Comments" v-model="comments" :rules="[fieldRules.maxLength(200)]" counter="200" dense outlined/>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer/>
          <v-btn plain color="primary" @click="$emit('done')">Cancel</v-btn>
          <v-btn color="primary" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>

<script>
export default {
  name: 'ProductionUpdateComments',
  props: {
    item: {type:Object, required:true},
    operation: {type: String, required:true}
  },
  data() {
    return {
      comments: ''
    }
  },
  created() {
    this.comments = this.item.comments;
  },
  methods: {
    async save() {
      const results = await this.$apiCall(`mutation ProductionUpdateComments($id: ID!, $comments: String!) {
                                              ${this.operation}(id:$id, comments:$comments) {
                                                comments
                                              }
                                            }`,
                                          {id:this.item.id, comments:this.comments});
      if (!results.error) {
        this.item.comments = results.data[this.operation].comments;
        this.$emit('done');
        this.$store.commit('setError', {type:'success',message:`Updated comments`});
      }
    }
  }
}
</script>